/* eslint-disable max-lines */
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined'
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import AddIcon from '@mui/icons-material/Add'
import AddLinkIcon from '@mui/icons-material/AddLink'
import AddModeratorIcon from '@mui/icons-material/AddModerator'
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings'
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined'
import AlignCenter from '@mui/icons-material/FormatAlignCenter'
import AlignJustify from '@mui/icons-material/FormatAlignJustify'
import AlignLeft from '@mui/icons-material/FormatAlignLeft'
import AlignRight from '@mui/icons-material/FormatAlignRight'
import ApprovalIcon from '@mui/icons-material/Approval'
import ArticleIcon from '@mui/icons-material/Article'
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft'
import AssessmentIcon from '@mui/icons-material/Assessment'
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined'
import AutorenewIcon from '@mui/icons-material/Autorenew'
import Bold from '@mui/icons-material/FormatBold'
import BookIcon from '@mui/icons-material/Book'
import BookOutlinedIcon from '@mui/icons-material/BookOutlined'
import BookmarkIcon from '@mui/icons-material/Bookmark'
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder'
import CheckIcon from '@mui/icons-material/Check'
import CircleIcon from '@mui/icons-material/Circle'
import CloseIcon from '@mui/icons-material/Close'
import CloudDownloadIcon from '@mui/icons-material/CloudDownload'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import DeleteIcon from '@mui/icons-material/Delete'
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined'
import DevicesIcon from '@mui/icons-material/Devices'
import DnsOutlinedIcon from '@mui/icons-material/DnsOutlined'
import EditIcon from '@mui/icons-material/Edit'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import EmergencyIcon from '@mui/icons-material/Emergency'
import EmergencyOutlinedIcon from '@mui/icons-material/EmergencyOutlined'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import FiberNewIcon from '@mui/icons-material/FiberNew'
import FileCopyIcon from '@mui/icons-material/FileCopy'
import FileDownloadIcon from '@mui/icons-material/FileDownload'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import GroupsIcon from '@mui/icons-material/Groups'
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined'
import HomeIcon from '@mui/icons-material/Home'
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty'
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined'
import ImageIcon from '@mui/icons-material/Image'
import InsertChartOutlinedIcon from '@mui/icons-material/InsertChartOutlined'
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile'
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined'
import Italic from '@mui/icons-material/FormatItalic'
import LaunchIcon from '@mui/icons-material/Launch'
import LinkIcon from '@mui/icons-material/Link'
import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined'
import MenuIcon from '@mui/icons-material/Menu'
import NoteAltIcon from '@mui/icons-material/NoteAlt'
import NoteAltOutlinedIcon from '@mui/icons-material/NoteAltOutlined'
import PersonIcon from '@mui/icons-material/Person'
import PhishingIcon from '@mui/icons-material/Phishing'
import PlagiarismOutlinedIcon from '@mui/icons-material/PlagiarismOutlined'
import SchoolIcon from '@mui/icons-material/School'
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined'
import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined'
import SettingsIcon from '@mui/icons-material/Settings'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import SpeedOutlinedIcon from '@mui/icons-material/SpeedOutlined'
import TaskAltIcon from '@mui/icons-material/TaskAlt'
import TerminalIcon from '@mui/icons-material/Terminal'
import TerminalOutlinedIcon from '@mui/icons-material/TerminalOutlined'
import TimelineIcon from '@mui/icons-material/Timeline'
import TimelineOutlinedIcon from '@mui/icons-material/TimelineOutlined'
import TrendingUpIcon from '@mui/icons-material/TrendingUp'
import TrendingUpOutlinedIcon from '@mui/icons-material/TrendingUpOutlined'
import type { IColor, ISxProps } from '@/CommonComponents/types'
import VideoFileIcon from '@mui/icons-material/VideoFile'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined'
import VpnLockIcon from '@mui/icons-material/VpnLock'
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined'
import PanToolAltOutlinedIcon from '@mui/icons-material/PanToolAltOutlined'
import PersonOutlineRoundedIcon from '@mui/icons-material/PersonOutlineRounded'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined'
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined'
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined'
import GppMaybeOutlinedIcon from '@mui/icons-material/GppMaybeOutlined'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import SensorsOutlinedIcon from '@mui/icons-material/SensorsOutlined'
import BugReportOutlinedIcon from '@mui/icons-material/BugReportOutlined'
import WifiOutlinedIcon from '@mui/icons-material/WifiOutlined'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import SecurityUpdateIcon from '@mui/icons-material/SecurityUpdate'
import ViewInArOutlinedIcon from '@mui/icons-material/ViewInArOutlined'
import HandymanOutlinedIcon from '@mui/icons-material/HandymanOutlined'
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts'
import CloudDoneOutlinedIcon from '@mui/icons-material/CloudDoneOutlined'
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined'
import CloudOutlinedIcon from '@mui/icons-material/CloudOutlined'
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined'
import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined'
import DevicesOutlinedIcon from '@mui/icons-material/DevicesOutlined'
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined'
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined'
import QuestionMarkOutlinedIcon from '@mui/icons-material/QuestionMarkOutlined'
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import InfoIcon from '@mui/icons-material/Info'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import PowerOutlinedIcon from '@mui/icons-material/PowerOutlined'
import FingerprintOutlinedIcon from '@mui/icons-material/FingerprintOutlined'
import CrisisAlertIcon from '@mui/icons-material/CrisisAlert'
// Custom SVG Icons
import { githubOutlinedIcon } from './githubIcon'
import { bitbucketOutlinedIcon } from './bitbucketIcon'
import { gitlabOutlinedIcon } from './gitlabIcon'

const MUI_ICONS = {
  // you can find the icons here https://mui.comi/components/material-icons/
  owner: PersonOutlineRoundedIcon,
  'account-circle': AccountCircleIcon,
  'arrow-back': ArrowBackIcon,
  add: AddIcon,
  'add-link': AddLinkIcon,
  'add-moderator': AddModeratorIcon,
  'align-center': AlignCenter,
  'align-justify': AlignJustify,
  'align-left': AlignLeft,
  'align-right': AlignRight,
  approval: ApprovalIcon,
  article: ArticleIcon,
  assessment: AssessmentIcon,
  'assessment-outlined': AssessmentOutlinedIcon,
  autorenew: AutorenewIcon,
  bold: Bold,
  book: BookIcon,
  'book-outlined': BookOutlinedIcon,
  bookmark: BookmarkIcon,
  'bookmark-border': BookmarkBorderIcon,
  'bug-report-outlined': BugReportOutlinedIcon,
  'calendar-outlined': CalendarMonthOutlinedIcon,
  'chart-outlined': InsertChartOutlinedIcon,
  check: CheckIcon,
  circle: CircleIcon,
  close: CloseIcon,
  'cloud-download': CloudDownloadIcon,
  'cloud-upload': CloudUploadIcon,
  code: TerminalIcon,
  copy: FileCopyIcon,
  'dashboard-outlined': DashboardOutlinedIcon,
  delete: DeleteIcon,
  'delete-outlined': DeleteOutlinedIcon,
  devices: DevicesIcon,
  'dns-outlined': DnsOutlinedIcon,
  'document-outlined': DescriptionOutlinedIcon,
  download: FileDownloadIcon,
  'download-outlined': FileDownloadOutlinedIcon,
  edit: EditIcon,
  'edit-outlined': EditOutlinedIcon,
  emergency: EmergencyIcon,
  'emergency-outlined': EmergencyOutlinedIcon,
  'evidence-outlined': PlagiarismOutlinedIcon,
  expandLess: ExpandLessIcon,
  expandMore: ExpandMoreIcon,
  eye: VisibilityIcon,
  'eye-outlined': VisibilityOutlinedIcon,
  file: InsertDriveFileIcon,
  'file-image': ImageIcon,
  'file-outlined': InsertDriveFileOutlinedIcon,
  'file-video': VideoFileIcon,
  'fingerprint-outlined': FingerprintOutlinedIcon,
  'handyman-outlined': HandymanOutlinedIcon,
  'gpp-maybe-outlined': GppMaybeOutlinedIcon,
  groups: GroupsIcon,
  'groups-outlined': GroupsOutlinedIcon,
  home: HomeIcon,
  'home-outlined': HomeOutlinedIcon,
  'hourglass-empty': HourglassEmptyIcon,
  italic: Italic,
  'info-outlined': InfoOutlinedIcon,
  'lock-outlined': LockOutlinedIcon,
  'language-outlined': LanguageOutlinedIcon,
  launch: LaunchIcon,
  'manage-accounts': ManageAccountsIcon,
  category: CategoryOutlinedIcon,
  cloud: CloudOutlinedIcon,
  schedule: ScheduleOutlinedIcon,
  verified: VerifiedOutlinedIcon,
  security: SecurityOutlinedIcon,
  left: ArrowLeftIcon,
  right: ArrowRightIcon,
  link: LinkIcon,
  'link-outlined': LinkOutlinedIcon,
  menu: MenuIcon,
  money: AttachMoneyIcon,
  'money-outlined': AttachMoneyOutlinedIcon,
  'new': FiberNewIcon,
  'note-alt': NoteAltIcon,
  'note-alt-outlined': NoteAltOutlinedIcon,
  person: PersonIcon,
  phishing: PhishingIcon,
  'power-outlined': PowerOutlinedIcon,
  'public-outlined': PublicOutlinedIcon,
  save: CloudUploadIcon,
  school: SchoolIcon,
  'school-outlined': SchoolOutlinedIcon,
  'sensors-outlined': SensorsOutlinedIcon,
  'security-outlined': SecurityOutlinedIcon,
  'security-update': SecurityUpdateIcon,
  settings: SettingsIcon,
  'settings-outlined': SettingsOutlinedIcon,
  'shield-people': AdminPanelSettingsIcon,
  'shield-people-outlined': AdminPanelSettingsOutlinedIcon,
  'speed-outlined': SpeedOutlinedIcon,
  task: TaskAltIcon,
  terminal: TerminalIcon,
  'terminal-outlined': TerminalOutlinedIcon,
  timeline: TimelineIcon,
  'timeline-outlined': TimelineOutlinedIcon,
  'trending-up': TrendingUpIcon,
  'trending-up-outlined': TrendingUpOutlinedIcon,
  'vpn-lock': VpnLockIcon,
  'pointer-outlined': PanToolAltOutlinedIcon,
  'wifi-outlined': WifiOutlinedIcon,
  'cube-outlined': ViewInArOutlinedIcon,
  'cloud-done-outlined': CloudDoneOutlinedIcon,
  'devices-outlined': DevicesOutlinedIcon,
  'storefront-outlined': StorefrontOutlinedIcon,
  'badge-outlined': BadgeOutlinedIcon,
  'shield-outlined': ShieldOutlinedIcon,
  'warning-outlined': WarningAmberOutlinedIcon,
  'question-mark-outlined': QuestionMarkOutlinedIcon,
  'search-outlined': SearchOutlinedIcon,
  'severity-critical': ErrorOutlineIcon,
  'severity-high': WarningAmberIcon,
  'severity-medium': InfoIcon,
  'severity-low': CheckCircleOutlineIcon,
  'crisis-alert': CrisisAlertIcon,
}

const CUSTOM_ICONS = {
  'github-outlined': githubOutlinedIcon,
  'bitbucket-outlined': bitbucketOutlinedIcon,
  'gitlab-outlined': gitlabOutlinedIcon,
}

const ICONS = { ...MUI_ICONS, ...CUSTOM_ICONS }
export type IAvailableIcons = keyof typeof ICONS

interface IIconProps {
  icon: IAvailableIcons
  sx?: ISxProps
  color?: IColor
}
function getCuratedSx(sx: ISxProps) {
  return sx ? Object.fromEntries(Object.entries(sx).filter(([_, value]) => value !== null)) : {}
}
const getIcon = ({ icon, sx, color }: IIconProps) => {
  const iconComponent = ICONS[icon]

  // Check if it's a custom SVG icon (function component)
  if (icon in CUSTOM_ICONS) {
    return iconComponent({ sx: getCuratedSx(sx || {}), color: color || 'inherit' })
  }

  // Material-UI icon
  if (icon in MUI_ICONS) {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const MuiIcon = iconComponent as React.ComponentType<{ sx?: ISxProps; color?: string }>
    return <MuiIcon sx={getCuratedSx(sx || {})} color={color || 'inherit'} />
  }

  return null
}

export default function Icon({ icon, sx, color }: IIconProps) {
  return getIcon({ icon, sx, color })
}
